
// import { useEffect, useState } from 'react';
// import {
//   deleteEducation,
//   getEducations,
//   postEducation,
//   updateEducation,
// } from '../API/res';

// const EducationSection = () => {
//   const [educations, setEducations] = useState([]);
//   const [forms, setForms] = useState([]);
//   const [editIndex, setEditIndex] = useState(null);
//   const [editData, setEditData] = useState({});

//   useEffect(() => {
//     const fetchEducations = async () => {
//       try {
//         const response = await getEducations();
//         setEducations(response.data);
//       } catch (err) {
//         console.error('Failed to fetch education records', err);
//       }
//     };
//     fetchEducations();
//   }, []);

//   const handleAddForm = () => {
//     setForms([
//       ...forms,
//       { degree: '', institution: '', start_date: '', end_date: '' },
//     ]);
//   };

//   const handleFormChange = (index, e) => {
//     const { name, value } = e.target;
//     const updatedForms = [...forms];
//     updatedForms[index][name] = value;
//     setForms(updatedForms);
//   };

//   const handleCancelForm = (index) => {
//     const updatedForms = [...forms];
//     updatedForms.splice(index, 1);
//     setForms(updatedForms);
//   };

//   const handleSubmit = async (index) => {
//     try {
//       await postEducation(forms[index]);
//       handleCancelForm(index);
//       const response = await getEducations();
//       setEducations(response.data);
//     } catch (err) {
//       console.error('Failed to add education', err);
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await deleteEducation(id);
//       const response = await getEducations();
//       setEducations(response.data);
//     } catch (err) {
//       console.error('Failed to delete education', err);
//     }
//   };

//   const handleEditClick = (index, edu) => {
//     setEditIndex(index);
//     setEditData(edu);
//   };

//   const handleEditChange = (e) => {
//     const { name, value } = e.target;
//     setEditData({ ...editData, [name]: value });
//   };

//   const handleEditCancel = () => {
//     setEditIndex(null);
//     setEditData({});
//   };

//   const handleUpdate = async (id) => {
//     try {
//       await updateEducation(id, editData);
//       setEditIndex(null);
//       setEditData({});
//       const response = await getEducations();
//       setEducations(response.data);
//     } catch (err) {
//       console.error('Failed to update education', err);
//     }
//   };

//   return (
//     <div className="p-4 max-w-2xl mx-auto">
//       <h2 className="text-2xl font-bold mb-6">Education</h2>

//       <button
//         onClick={handleAddForm}
//         className="mb-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
//       >
//         + Add Education
//       </button>

//       {/* Add Form */}
//       {forms.map((form, index) => (
//         <div key={index} className="bg-gray-50 border p-4 rounded mb-6 shadow-sm space-y-4">
//           <div>
//             <label className="block font-medium mb-1">Degree</label>
//             <input
//               name="degree"
//               value={form.degree}
//               onChange={(e) => handleFormChange(index, e)}
//               className="w-full p-2 border rounded"
//               placeholder="e.g. B.Tech in Computer Science"
//             />
//           </div>

//           <div>
//             <label className="block font-medium mb-1">Institution</label>
//             <input
//               name="institution"
//               value={form.institution}
//               onChange={(e) => handleFormChange(index, e)}
//               className="w-full p-2 border rounded"
//               placeholder="e.g. IIT Delhi"
//             />
//           </div>

//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block font-medium mb-1">Start Date</label>
//               <input
//                 type="date"
//                 name="start_date"
//                 value={form.start_date}
//                 onChange={(e) => handleFormChange(index, e)}
//                 className="w-full p-2 border rounded"
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-1">End Date</label>
//               <input
//                 type="date"
//                 name="end_date"
//                 value={form.end_date}
//                 onChange={(e) => handleFormChange(index, e)}
//                 className="w-full p-2 border rounded"
//               />
//             </div>
//           </div>

//           <div className="flex gap-2">
//             <button
//               onClick={() => handleSubmit(index)}
//               className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//             >
//               Save
//             </button>
//             <button
//               onClick={() => handleCancelForm(index)}
//               className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       ))}

//       {/* Existing Entries */}
//       <h3 className="text-xl font-semibold mt-10 mb-4">Your Education</h3>

//       {educations.length === 0 ? (
//         <p className="text-gray-600">No education records found.</p>
//       ) : (
//         <ul className="space-y-4">
//           {educations.map((edu, index) => (
//             <li key={edu.id} className="border p-4 rounded shadow-sm">
//               {editIndex === index ? (
//                 <div className="space-y-4">
//                   <div>
//                     <label className="block font-medium mb-1">Degree</label>
//                     <input
//                       name="degree"
//                       value={editData.degree}
//                       onChange={handleEditChange}
//                       className="w-full p-2 border rounded"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-medium mb-1">Institution</label>
//                     <input
//                       name="institution"
//                       value={editData.institution}
//                       onChange={handleEditChange}
//                       className="w-full p-2 border rounded"
//                     />
//                   </div>
//                   <div className="grid grid-cols-2 gap-4">
//                     <div>
//                       <label className="block font-medium mb-1">Start Date</label>
//                       <input
//                         type="date"
//                         name="start_date"
//                         value={editData.start_date}
//                         onChange={handleEditChange}
//                         className="w-full p-2 border rounded"
//                       />
//                     </div>
//                     <div>
//                       <label className="block font-medium mb-1">End Date</label>
//                       <input
//                         type="date"
//                         name="end_date"
//                         value={editData.end_date}
//                         onChange={handleEditChange}
//                         className="w-full p-2 border rounded"
//                       />
//                     </div>
//                   </div>

//                   <div className="flex gap-2">
//                     <button
//                       onClick={() => handleUpdate(edu.id)}
//                       className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//                     >
//                       Update
//                     </button>
//                     <button
//                       onClick={handleEditCancel}
//                       className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="flex justify-between items-start gap-4">
//                   <div className="space-y-1">
//                     <p><span className="font-semibold">Degree:</span> {edu.degree}</p>
//                     <p><span className="font-semibold">Institution:</span> {edu.institution}</p>
//                     <p><span className="font-semibold">Duration:</span> {edu.start_date} to {edu.end_date}</p>
//                   </div>
//                   <div className="flex flex-col gap-2">
//                     <button
//                       onClick={() => handleEditClick(index, edu)}
//                       className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(edu.id)}
//                       className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default EducationSection;

import { useEffect, useState } from 'react';
import {
  deleteEducation,
  getEducations,
  postEducation,
  updateEducation,
} from '../API/res';

const EducationSection = () => {
  const [educations, setEducations] = useState([]);
  const [forms, setForms] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    const fetchEducations = async () => {
      try {
        const response = await getEducations();
        setEducations(response.data);
      } catch (err) {
        console.error('Failed to fetch education records', err);
      }
    };
    fetchEducations();
  }, []);

  const handleAddForm = () => {
    setForms([
      ...forms,
      { degree: '', institution: '', start_date: '', end_date: '' },
    ]);
  };

  const handleFormChange = (index, e) => {
    const { name, value } = e.target;
    const updatedForms = [...forms];
    updatedForms[index][name] = value;
    setForms(updatedForms);
  };

  const handleCancelForm = (index) => {
    const updatedForms = [...forms];
    updatedForms.splice(index, 1);
    setForms(updatedForms);
  };

  const handleSubmit = async (index) => {
    try {
      await postEducation(forms[index]);
      handleCancelForm(index);
      const response = await getEducations();
      setEducations(response.data);
    } catch (err) {
      console.error('Failed to add education', err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteEducation(id);
      const response = await getEducations();
      setEducations(response.data);
    } catch (err) {
      console.error('Failed to delete education', err);
    }
  };

  const handleEditClick = (index, edu) => {
    setEditIndex(index);
    setEditData(edu);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleEditCancel = () => {
    setEditIndex(null);
    setEditData({});
  };

  const handleUpdate = async (id) => {
    try {
      await updateEducation(id, editData);
      setEditIndex(null);
      setEditData({});
      const response = await getEducations();
      setEducations(response.data);
    } catch (err) {
      console.error('Failed to update education', err);
    }
  };

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Education</h2>

      <button
        onClick={handleAddForm}
        className="mb-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        + Add Education
      </button>

      {/* Add Form */}
      {forms.map((form, index) => (
        <div key={index} className="bg-gray-50 border p-4 rounded mb-6 shadow-sm space-y-4">
          <div>
            <label className="block font-medium mb-1">Degree</label>
            <input
              name="degree"
              value={form.degree}
              onChange={(e) => handleFormChange(index, e)}
              className="w-full p-2 border rounded"
              placeholder="e.g. B.Tech in Computer Science"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Institution</label>
            <input
              name="institution"
              value={form.institution}
              onChange={(e) => handleFormChange(index, e)}
              className="w-full p-2 border rounded"
              placeholder="e.g. IIT Delhi"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block font-medium mb-1">Start Date</label>
              <input
                type="date"
                name="start_date"
                value={form.start_date}
                onChange={(e) => handleFormChange(index, e)}
                className="w-full p-2 border rounded"
              />
            </div>
            <div>
              <label className="block font-medium mb-1">End Date</label>
              <input
                type="date"
                name="end_date"
                value={form.end_date}
                onChange={(e) => handleFormChange(index, e)}
                className="w-full p-2 border rounded"
              />
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <button
              onClick={() => handleSubmit(index)}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Save
            </button>
            <button
              onClick={() => handleCancelForm(index)}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
          </div>
        </div>
      ))}

      {/* Existing Entries */}
      <h3 className="text-xl font-semibold mt-10 mb-4">Your Education</h3>

      {educations.length === 0 ? (
        <p className="text-gray-600">No education records found.</p>
      ) : (
        <ul className="space-y-4">
          {educations.map((edu, index) => (
            <li key={edu.id} className="border p-4 rounded shadow-sm">
              {editIndex === index ? (
                <div className="space-y-4">
                  <div>
                    <label className="block font-medium mb-1">Degree</label>
                    <input
                      name="degree"
                      value={editData.degree}
                      onChange={handleEditChange}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div>
                    <label className="block font-medium mb-1">Institution</label>
                    <input
                      name="institution"
                      value={editData.institution}
                      onChange={handleEditChange}
                      className="w-full p-2 border rounded"
                    />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block font-medium mb-1">Start Date</label>
                      <input
                        type="date"
                        name="start_date"
                        value={editData.start_date}
                        onChange={handleEditChange}
                        className="w-full p-2 border rounded"
                      />
                    </div>
                    <div>
                      <label className="block font-medium mb-1">End Date</label>
                      <input
                        type="date"
                        name="end_date"
                        value={editData.end_date}
                        onChange={handleEditChange}
                        className="w-full p-2 border rounded"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <button
                      onClick={() => handleUpdate(edu.id)}
                      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                    >
                      Update
                    </button>
                    <button
                      onClick={handleEditCancel}
                      className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col sm:flex-row justify-between sm:items-start gap-4">
                  <div className="space-y-1">
                    <p><span className="font-semibold">Degree:</span> {edu.degree}</p>
                    <p><span className="font-semibold">Institution:</span> {edu.institution}</p>
                    <p><span className="font-semibold">Duration:</span> {edu.start_date} to {edu.end_date}</p>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                    <button
                      onClick={() => handleEditClick(index, edu)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(edu.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EducationSection;

